export default __webpack_public_path__ + "static/uniformSchoolBags-9d23c44c68f5507d505012880639ae72.jpg";